import axios from "axios";
// "http://localhost:8081/api"
// "https://salfad-back-1fc9ebcced82.herokuapp.com/api"
export const makeRequest = axios.create({
    baseURL:"https://salfad-back-1fc9ebcced82.herokuapp.com/api",
    withCredentials:true,
});